export default __webpack_public_path__ + "static/municipal-e08e1db3fa3a5405571c242421a914cf.png";